import { useCallback, useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import { Query } from '../../services/graphql/query';
import GraphqlService from '../../services/graphql/GraphqlService';
import {
  ISettingProperties,
  ISettingToUpdate,
  ISettingType,
} from '../../interfaces/TenantSetting';

type ReceiptDateEnumSelectProps = {
  settingsArray: ISettingToUpdate[];
  handleChange: (id: any, value: any) => void;
};

export const useSettingReceiptDateEnum = (
  props: ReceiptDateEnumSelectProps,
) => {
  const { settingsArray, handleChange } = props;
  const [receiptDateTypes, setReceiptDateTypes] = useState<any[]>([]);
  const { customRequest } = GraphqlService();

  useEffect(() => {
    getUploadDateTypes();
  }, []);

  const getUploadDateTypes = async () => {
    const data = await customRequest({
      query: Query.uploadDateTypeList,
    });

    if (Array.isArray(data)) {
      setReceiptDateTypes(data);
    }
  };

  const ReceiptDateEnumSelect = useCallback(
    (props: ISettingProperties) => {
      const valueSelected = settingsArray
        .find((item) => item.id === props.id)
        ?.value?.toString();

      return (
        <Form.Item
          className="margin-component"
          required
          key={props.key || undefined}
        >
          <Select
            className="select-receipt-date-enum"
            onChange={(e) => handleChange(props.id, e)}
            value={valueSelected}
            getPopupContainer={(node) => node.parentNode}
            options={receiptDateTypes.map((item) => ({
              label: item.label,
              value: item.code,
            }))}
          />
        </Form.Item>
      );
    },
    [settingsArray, handleChange],
  );

  const receiptDateEnumSetting: ISettingType = {
    render: useCallback(
      (props) => {
        return <ReceiptDateEnumSelect {...props} />;
      },
      [ReceiptDateEnumSelect],
    ),
  };

  return { receiptDateEnumSetting };
};

export default useSettingReceiptDateEnum;
